import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface PartnerRequest {
  id: string;
  user_id?: string | null;
  name?: string | null;
  phone?: string | null;
  email: string;
  dob?: string | null;
  address?: string | null;
  country?: string | null;
  how_joined?: string | null;
  avatar_url?: string | null;
  created_at?: string | null;
  verified?: boolean | null;
}

export const usePartnerRequests = () => {
  return useQuery<PartnerRequest[]>({
    queryKey: ['partnerRequests'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('partner_requests')
        .select('id, user_id, name, phone, email, dob, address, country, how_joined, avatar_url, created_at, verified')
        .order('created_at', { ascending: false })
        .limit(500);

      if (error) throw error;
      return (data as PartnerRequest[]) ?? [];
    },
    staleTime: 60_000,
  });
};
